import React, { useCallback } from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";
import validator from "validator";

import { useFeatures } from "components/FeatureFlag";
import URLMessage from "components/URLMessage";

import { MailToMessage } from "scenes/Authentication/components/Layout/components";

const withTargetBlank = (u) => {
  return { ...u, target: "_blank" };
};
function HintComposer({
  cause,
  suggestions,
  reloadButton,
  onSuggestedHintClicked,
}) {
  const howtoAction = useFeatures("insights-upgrade-plan.howtoAction");

  const getHowToUrl = useCallback(
    (tag) => {
      const howtoUrl = howtoAction?.[tag];
      return howtoUrl && validator.isURL(howtoUrl) ? howtoUrl : null;
    },
    [howtoAction]
  );

  return (
    <div data-test="hint-composer">
      <div data-test="hint-composer-cause">
        <MailToMessage>{cause}</MailToMessage>
      </div>
      {Array.isArray(suggestions) && suggestions.length > 0 && (
        <ul data-test="hint-composer-suggestions">
          {suggestions.map(({ message, howtoTag, keywords }) => {
            const howtoUrl = getHowToUrl(howtoTag);

            return (
              <li key={message}>
                <URLMessage
                  onKeywordClick={onSuggestedHintClicked}
                  keywords={[
                    { keyword: "support", url: "mailto:support@myhubly.com" },
                  ].concat((keywords || []).map(withTargetBlank))}
                >
                  {message}
                </URLMessage>{" "}
                {howtoUrl && (
                  <a
                    href={howtoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onSuggestedHintClicked}
                  >
                    <Icon
                      data-test="suggestion-help-icon"
                      link
                      name="question circle outline"
                      color="blue"
                      title="Help"
                    />
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {reloadButton}
    </div>
  );
}

HintComposer.propTypes = {
  cause: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.object),
  onSuggestedHintClicked: PropTypes.func,
  reloadButton: PropTypes.node,
};

HintComposer.defaultProps = {
  cause: "",
  suggestions: [],
  reloadButton: undefined,
  onSuggestedHintClicked: () => {},
};

export default HintComposer;
